import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import './ComingSoon.css';

const ComingSoon = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="coming-soon-page">
      <Header isLoggedIn={false} />

      <div className="coming-soon-container">
        <div className="coming-soon-card">

          {/* Animated character */}
          <div className="cs-character" aria-hidden="true">
            <div className="cs-body">
              <div className="cs-eye left"></div>
              <div className="cs-eye right"></div>
              <div className="cs-mouth"></div>
              <div className="cs-hat"></div>
            </div>
            <div className="cs-tools">
              <span className="cs-tool tool-1">🔧</span>
              <span className="cs-tool tool-2">⭐</span>
              <span className="cs-tool tool-3">🎨</span>
            </div>
          </div>

          {/* Message */}
          <h1 className="cs-title">We're Working On It!</h1>
          <p className="cs-subtitle">
            This page is being built with lots of love and care.
          </p>
          <p className="cs-path">
            <span className="cs-path-label">Page:</span>
            <code>{location.pathname}</code>
          </p>
          <p className="cs-description">
            Our team is busy creating something amazing for you.
            Check back soon — it'll be worth the wait! 🚀
          </p>

          {/* Actions */}
          <div className="cs-actions">
            <button
              className="cs-btn cs-btn-primary"
              onClick={() => navigate('/')}
            >
              <i className="fas fa-home" aria-hidden="true"></i>
              Go to Home
            </button>
            <button
              className="cs-btn cs-btn-secondary"
              onClick={() => navigate(-1)}
            >
              <i className="fas fa-arrow-left" aria-hidden="true"></i>
              Go Back
            </button>
          </div>

          {/* Fun footer note */}
          <p className="cs-fun-note">
            While you wait, keep practising your words! 📚
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
